/* @flow */
import * as React from "react";
import {
  withColorsProvider,
  type ColorSet,
} from "nx-components/ColorsProvider";
import type { StylesObject } from "nx-components/utils/prefixStyles";
import ErrorHandler from "nexia_mobile/components/ErrorHandler";

const DetailsHeaderOffscreenOverscroll = withColorsProvider(({ colors }) => (
  /*
    Add some offscreen grey so that if the user overscrolls downwards
    on the details page, it's still grey "behind" the title bar.
  */
  <div
    data-component-name="DetailsHeaderOffscreenOverscroll"
    style={{
      marginTop: "-100vh",
      height: "100vh",
      background: colors.DETAILS_HEADER_BACKGROUND,
      // This transform is here to prevent Mobile Safari from applying
      // an optimization where it doesn't render an "offscreen" element.
      transform: "translate3d(0, 0, 0)",
    }}
  />
));

export { DetailsHeaderOffscreenOverscroll };

type Props = {
  children?: ?React.Node,
  style?: ?StylesObject,
  innerRef?: ?(?HTMLDivElement) => void,
  colors: ColorSet,
};

const DetailsHeaderWrapper = ({ children, style, innerRef, colors }: Props) => (
  <ErrorHandler>
    <div
      style={{
        color: colors.PRIMARY,
        background: colors.DETAILS_HEADER_BACKGROUND,
        padding: "1em",
        textAlign: "center",
        position: "relative",
        ...style,
      }}
      ref={innerRef}
    >
      {children}
    </div>
  </ErrorHandler>
);

export default withColorsProvider(DetailsHeaderWrapper);



// WEBPACK FOOTER //
// ./src/components/Details/DetailsHeaders/DetailsHeaderWrapper.jsx